import type { ReactNode } from "react";

interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  description?: string;
  align?: "left" | "center";
  accent?: "primary" | "accent" | "secondary";
}

const accentClasses: Record<string, string> = {
  primary: "bg-primary-100 text-primary-700",
  accent: "bg-accent-100 text-accent-900",
  secondary: "bg-secondary-100 text-secondary-900",
};

export default function SectionHeading({
  eyebrow,
  title,
  description,
  align = "left",
  accent = "primary",
}: SectionHeadingProps) {
  const isCenter = align === "center";
  return (
    <div className={`${isCenter ? "text-center mx-auto" : ""} max-w-3xl mb-8 md:mb-12`}>
      <span
        className={`inline-block px-3 py-1 rounded-full text-xs md:text-sm font-label tracking-wide ${accentClasses[accent]}`}
      >
        {eyebrow}
      </span>
      <h2 className="mt-4 font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-snug">
        {title}
      </h2>
      {description ? (
        <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">{description}</p>
      ) : null}
    </div>
  );
}

export function Section({ id, children, className = "" }: { id: string; children: ReactNode; className?: string }) {
  return (
    <section id={id} className={`w-full ${className}`}>
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6 py-12 md:py-16">{children}</div>
    </section>
  );
}